import { AccountingSubNav } from '../components/AccountingSubNav';
import { Gstr2bReportComponent } from '@/features/accounts/components/reports/Gstr2bReportComponent';

export function AccountingGstr2Page() {
  return (
    <div>
      <AccountingSubNav />
      <div className=" pb-16">
        <Gstr2bReportComponent />
      </div>
    </div>
  );
}
